import {BoxProps, ComponentWithAs, Flex, IconProps, Image} from '@chakra-ui/react';

import {CoinIcon, LockFilledIcon} from '@eksab/assets/icons';

import {Article} from '../types';

interface ArticleBadgesProps extends BoxProps {
  sponsor?: Article['sponsor'];
  canEarn?: boolean;
  isLocked?: boolean;
}

export const ArticleBadges = ({sponsor, canEarn, isLocked, ...props}: ArticleBadgesProps) => (
  <Flex flexDir="column" gap="1.5" pos="absolute" top="2.5" insetInlineEnd="5" cursor="initial" {...props}>
    {sponsor && (
      <ArticleBadge badgeName="الراعي" title={sponsor.name} logo={sponsor.logo?.thumb ?? sponsor.logo?.original} />
    )}

    {canEarn && <ArticleBadge badgeName="اكسب كوينز" logo={CoinIcon} />}

    {isLocked && <ArticleBadge badgeName="مستخدمين فقط" logo={LockFilledIcon} />}
  </Flex>
);

interface ArticleBadgeProps {
  badgeName: string;
  title?: string;
  logo: ComponentWithAs<'svg', IconProps> | string | undefined;
}

const ArticleBadge = ({title, logo: Logo, badgeName}: ArticleBadgeProps) =>
  Logo ? (
    <Flex justify="center" align="center" boxSize="6" p="0.5" rounded="sm" bg="white">
      {typeof Logo === 'string' ? (
        <Image width="full" objectFit="cover" src={Logo} title={title ?? badgeName} alt={title ?? badgeName} />
      ) : (
        <Logo width="full" objectFit="cover" />
      )}
    </Flex>
  ) : null;
